import { AccountService } from "./auth/account.service";
import { AuthServerProvider } from "./auth/auth-jwt.service";
import { SERVER_API_URL } from "../app.constants";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./auth/account.service";
import * as i3 from "./auth/auth-jwt.service";
var LoginService = /** @class */ (function () {
    function LoginService(http, accountService, authServerProvider) {
        this.http = http;
        this.accountService = accountService;
        this.authServerProvider = authServerProvider;
        this.hostUrl = SERVER_API_URL;
        this.urlToResetPassword = this.hostUrl + 'api/account/reset-password/init';
    }
    LoginService.prototype.login = function (credentials, callback) {
        var _this = this;
        var cb = callback || function () { };
        return new Promise(function (resolve, reject) {
            _this.authServerProvider.login(credentials).subscribe(function (data) {
                _this.accountService.identity(true).then(function (account) {
                    resolve(data);
                });
                return cb();
            }, function (err) {
                _this.logout();
                reject(err);
                return cb(err);
            });
        });
    };
    LoginService.prototype.loginWithToken = function (jwt, rememberMe) {
        return this.authServerProvider.loginWithToken(jwt, rememberMe);
    };
    LoginService.prototype.resetPassword = function (mail) {
        return this.http
            .post(this.urlToResetPassword, mail)
            .pipe(map(function (response) { return response; }));
    };
    LoginService.prototype.logout = function () {
        this.authServerProvider.logout().subscribe();
        this.accountService.authenticate(null);
    };
    LoginService.ngInjectableDef = i0.defineInjectable({ factory: function LoginService_Factory() { return new LoginService(i0.inject(i1.HttpClient), i0.inject(i2.AccountService), i0.inject(i3.AuthServerProvider)); }, token: LoginService, providedIn: "root" });
    return LoginService;
}());
export { LoginService };
